export class AABBModel {
    public pos: [number, number] = [0, 0];
    public initialPos: [number, number] = [0, 0];

    public screenPos: [number, number] = [0, 0];
    public width: number = 100;
    public height: number = 100;
    public padding: [number, number] = [0, 0];

    public target: [number, number] = null;

    public get zOrder() {
        return this.pos[1];
    }

    public highlight: boolean = false;

    constructor() {

    }

    get aabb(): [number, number, number, number] {
        return [this.pos[0] + this.padding[0], this.pos[1] - this.height + this.padding[1], this.width, this.height];
    }

    private _intersects(aabb: [number, number, number, number]): boolean {
        let _aabb = this.aabb;
        let result = false;
        if (_aabb[0] < aabb[0] + aabb[2] &&
            _aabb[0] + _aabb[2] > aabb[0] &&
            _aabb[1] < aabb[1] + aabb[3] &&
            _aabb[1] + _aabb[3] > aabb[1]) {
            result = true;
        }
        return result;
    }

    public checkPos(pos: [number, number]): boolean {
        let res = this._intersects([pos[0] - 1, pos[1] - 1, 2, 2]);
        return res;
    }

    public check(aabb: [number, number, number, number]): boolean {
        return this._intersects(aabb);
    }
}
